"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Step = _antd.Steps.Step;
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Steps, {
    current: 1
  }, /*#__PURE__*/_react.default.createElement(Step, {
    title: "Finished",
    description: "This is a description."
  }), /*#__PURE__*/_react.default.createElement(Step, {
    title: "In Progress",
    subTitle: "Left 00:00:08",
    description: "This is a description."
  }), /*#__PURE__*/_react.default.createElement(Step, {
    title: "Waiting",
    description: "This is a description."
  }));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorPrimary', 'colorBgContainer'],
  key: 'default'
};
var _default = exports.default = componentDemo;